// Only one product-detail accordion open at a time.
(function () {
  var items = document.querySelectorAll('.product-editorial__accordions .product-accordions__item');
  items.forEach(function (item) {
    item.addEventListener('toggle', function () {
      if (!item.open) return;
      items.forEach(function (other) {
        if (other !== item) other.open = false;
      });
    });
  });
})();
